import React from "react";
import { useNavigate } from "react-router-dom";
import umadras from "../../../assets/images/umadras.png";
import bless from "../../../assets/images/bless.png";
import bloom from "../../../assets/images/bloom.png";
import "../../../assets/css/Product.css";

const Product = () => {
  const navigate = useNavigate();
  const products = [
    {
      title: "U",
      tagline: "Where elegance meets flair.",
      description:
        "Introducing 'U'—where elegance meets flair. Designed for the modern woman, 'U' blends chic comfort with striking style, perfect for any occasion. With bold cuts, luxurious fabrics and meticulous detail, 'U' lets you shine effortlessly, every day.",
      image: umadras,
      route: "/umadras"
    },
    {
      title: "B'Less",
      tagline: "True freedom, redefined.",
      description:
        "Introducing B'Less—a revolutionary braless apparel line for women who crave true freedom. Say goodbye to discomfort and hello to effortless form-filled style and liberation. Designed for both lounging and stepping out, B'Less moves with you, offering unmatched comfort and confidence. With B'Less, freedom never felt so empowering.",
      image: bless,
       route: "/bless"
    },
    {
      title: "Bloom",
      tagline: "Fashion that empowers resilience.",
      description:
        "Introducing BLOOM—a compassionate apparel line for women who have undergone mastectomy. Each piece is more than just comfort; it's a symbol of resilience and confidence. Thoughtfully crafted to offer support, BLOOM helps women embrace their healing journey with grace. With BLOOM, fashion becomes empowerment, allowing every woman to bloom in her strength.",
      image: bloom,
       route: "/bloom"
    },
  ];
  const handleRedirect = (route) => {
    navigate(route);
  };


  return (
    <div className="product-container" id="brands">
      {products.map((product, index) => (
        <div key={index} className="product-card">
          <img src={product.image} alt={product.title} className="product-image" onClick={() => handleRedirect(product.route)}  style={{ cursor: "pointer" }}  />
          <p className="product-description">{product.description}</p>
          <div>
          <button className="product-button"onClick={() => handleRedirect(product.route)} >Know More &gt;</button>
          </div>
        </div>
       
      ))}
    </div>
  );
};

export default Product;
